import { createClient } from '@/lib/supabase/client';

export interface LegalPage {
  id: string;
  slug: string;
  title: string;
  content: string;
  updatedAt: string;
  createdAt: string;
}

interface LegalPageRow {
  id: string;
  slug: string;
  title: string;
  content: string;
  updated_at: string;
  created_at: string;
}

function mapRow(row: LegalPageRow): LegalPage {
  return {
    id: row.id,
    slug: row.slug,
    title: row.title,
    content: row.content,
    updatedAt: row.updated_at,
    createdAt: row.created_at,
  };
}

export const legalPageService = {
  async getBySlug(slug: string): Promise<LegalPage | null> {
    const supabase = createClient();
    const { data, error } = await supabase
      .from('legal_pages')
      .select('*')
      .eq('slug', slug)
      .maybeSingle();

    if (error || !data) return null;
    return mapRow(data as LegalPageRow);
  },

  async upsert(slug: string, title: string, content: string): Promise<LegalPage | null> {
    const supabase = createClient();
    const { data, error } = await supabase
      .from('legal_pages')
      .upsert(
        { slug, title, content, updated_at: new Date().toISOString() },
        { onConflict: 'slug' }
      )
      .select()
      .single();

    if (error) throw new Error(error.message);
    return mapRow(data as LegalPageRow);
  },
};
